import { Controller } from "@hotwired/stimulus"

// Bootstrap 3 triggers its modal events through jQuery, so they never reach
// native listeners — data-action can't subscribe to shown/hide.bs.modal.
export default class extends Controller {
  connect() {
    $(this.element)
      .on("shown.bs.modal", () => this.element.setAttribute("data-shown", ""))
      .on("hide.bs.modal", () => this.element.removeAttribute("data-shown"))
  }

  disconnect() {
    $(this.element).off("shown.bs.modal hide.bs.modal")
  }

  showWithEmail(event) {
    $("#session-modal").modal("show")
    const { email, title } = event.detail
    if (title) {
      $("#session-body .modal-title").html(title)
    }
    if (email) {
      const input = document.getElementById("user_login")
      input.value = email
    }
  }
}
